<template>
    <div id="ambis-meter">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Ambis Meter' },
            ]"
            divider=">"
        ></v-breadcrumbs>
        <h3 class="header-text font-weight-bold">List Periode Ambis Meter</h3>

        <v-card>
            <v-card-title>
                Periode Ambis Meter
                <v-spacer></v-spacer>
                <!-- <v-btn
          class="align-center text-body-2 blew white--text mr-5"
          @click="getListQuote()"
        >
          Quotes
        </v-btn> -->
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    @click="createAmbisMeter()"
                >
                    <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Ambis Meter
                </v-btn>
            </v-card-title>
            <v-divider />

            <app-datatable
                :items="ambismeters"
                :headers="headers"
                :has-action="true"
                :has-leaderboard="true"
                :key="tableKey"
                :customWidth="true"
                :custom-pagination-total-items="ambismeters.length"
                :custom-pagination-per-page="10"
                :custom-pagination-current-page="1"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editAmbisMeter()"
                v-on:duplicateClicked="duplicateAmbisMeter()"
                v-on:leaderboardClicked="goToLeaderboard()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";
import Moment from "moment";

export default {
    name: "ambis-meter",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            selectedRow: null,
            search: "",
            tableKey: 0,
            pagination: {
                perPage: 1000,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            ambismeters: [],
            headers: [
                { text: "Nama", value: "name" },
                { text: "Deskripsi", value: "description", max_width: "5px" },
                { text: "Start Date", value: "start_date" },
                { text: "End Date", value: "end_date" },
                { text: "Aksi", value: "actions" },
            ],
            headersKey: ["name", "description", "start_date", "end_date"],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        fetchData: function () {
            var context = this;
            var search = this.search;
            this.ambismeters = [];
            var pagination = {
                size: this.pagination.perPage,
                page: this.pagination.currentPage,
            };

            AmbisMeterService.getListPeriode(pagination, search, (result) => {
                if (result.success) {
                    result.data.periodes.forEach(function (response, index) {
                        var startDate = Moment(response.start_date).format(
                            "DD-MM-YYYY",
                        );
                        var endDate = Moment(response.end_date).format(
                            "DD-MM-YYYY",
                        );
                        var row = {
                            no: index,
                            id: response.id,
                            name: response.name,
                            description: response.description,
                            is_active: response.is_active,
                            start_date: startDate,
                            end_date: endDate,
                        };

                        context.ambismeters.push(row);
                        context.ambismeters = _.orderBy(
                            context.ambismeters,
                            "id",
                            "desc",
                        );
                        context.isLoading = false;
                    });
                }
                context.isLoading = false;
            });
        },

        getListQuote: function () {
            this.$router.push({ path: "/quote" });
        },

        createAmbisMeter: function () {
            this.$router.push({ path: "/ambis-meter-form" });
        },

        editAmbisMeter: function () {
            var context = this;
            context.isLoading = true;
            var ambisId = context.selectedRow.id;
            context.$store.commit("periode_init", this.selectedRow);
            context.$router.push({
                path: "/ambis-meter-edit-form",
                query: { id: ambisId },
            });
        },

        goToLeaderboard: function () {
            var context = this;
            var ambisId = this.selectedRow.id;
            context.$router.push({
                path: "/leaderboard",
                query: { id: ambisId },
            });
        },

        duplicateAmbisMeter: function () {},
    },
};
</script>



// WEBPACK FOOTER //
// AmbisMeter.vue?55177fd8